import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import routes from 'constants/routes.json';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  button: {
    color: 'white',
  },
}));

export default function TitleBar() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { classMode, firstName, lastName, moodle } = useSelector(({ user }) => user);
  const history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const goToLogin = () => {
    history.push(routes.LOGIN);
  };

  const logout = () => {
    localStorage.clear();
    dispatch({
      type: 'RESET_USER',
    });
    history.push(routes.HOME);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar>
          <Typography
            onClick={() => history.push('/')}
            style={{ cursor: 'pointer', width: '300px' }}
            variant="h6"
            className={classes.title}
          >
            Combobulate Meeting
          </Typography>
          <Box flexGrow={1} />
          {classMode ? (
            <>
              {moodle ? (
                <span data-testid="moodle-user">{`${firstName} ${lastName.charAt(0)}`}</span>
              ) : (
                <Button
                  data-testid="standard-user"
                  className={classes.button}
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  {`${firstName} ${lastName.charAt(0)}`}
                </Button>
              )}
            </>
          ) : (
            <Button onClick={() => goToLogin()} color="inherit">
              Login
            </Button>
          )}
          <Menu
            id="user-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={logout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    </div>
  );
}
